import { StyledProps, React, withStyles }                                     from '@api';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, CircularProgress } from '@material-ui/core'
import {observer} from 'mobx-react'

const styles = theme => ({
  modal:                {
    height:       '640px',
    width:        '640px',
    borderRadius: 2,
    boxShadow:    '0 8px 10px 0 rgba(0, 0, 0, 0.2), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14)'
  },
  modalTag:             {
    height:       '250px',
    width:        '250px',
    borderRadius: 2,
    boxShadow:    '0 8px 10px 0 rgba(0, 0, 0, 0.2), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14)'
  },
  backdropRoot:         {
    backgroundColor: 'rgba(255, 255, 255, 0.7)'
  },
  actionRoot:           {
    margin: '22px 19px'
  },
  title:                {
    fontSize:      '24px',
    textAlign:     'center',
    color:         'rgba(27, 27, 27, 0.87)',
    lineHeight:    1.17,
    letterSpacing: 'normal',
    fontWeight:    'normal'
  },
  titleTag:             {
    fontSize:      '16px',
    textAlign:     'center',
    color:         'rgba(27, 27, 27, 0.87)',
    letterSpacing: 'normal',
    fontWeight:    'normal'
  },
  rootTitle:            {
    flex:    '0 0 auto',
    margin:  0,
    padding: '24px 24px 20px'
  },
  rootTitleTag:         {
    flex:    '0 0 auto',
    margin:  0,
    padding: '11px 0px 11px'
  },
  dialogContentRoot:    {
    flex:      '1 1 auto',
    padding:   '0 24px 24px',
    overflowY: 'auto'
  },
  dialogContentRootTag: {
    flex:      '1 1 auto',
    padding:   '30px 41px 24px',
    overflowY: 'auto'
  },
  buttonProgress:      {
    position:   'absolute'
  }
})

interface MyProps extends StyledProps {
  showModal?: boolean
  onCloseModal?: (e) => void,
  title?: string,
  onClickCreate?: (e) => void,
  isEdit?: boolean
  isTag?: boolean
}

@(withStyles as any)(styles)
@observer
export class ModalComponent extends React.Component <MyProps> {
  render() {
    const {classes, children, showModal, onCloseModal, onClickCreate, title, isEdit, isTag} = this.props
    const saveInProgress = false // todo ES
    //let {saveInProgress} = sidebar
    return (
      <Dialog
        open={showModal}
        onClose={() => {}}
        classes={{paper: isTag ? classes.modalTag : classes.modal}}
        BackdropProps={{classes: {root: classes.backdropRoot}}}
      >
        <DialogTitle classes={{root: isTag ? classes.rootTitleTag : classes.rootTitle}}>
          <div className={isTag ? classes.titleTag : classes.title}> {title} </div>
        </DialogTitle>
        <Divider/>
        <DialogContent classes={{root: isTag ? classes.dialogContentRootTag : classes.dialogContentRoot}} className='full-height'>
          {children}
        </DialogContent>
        <DialogActions classes={{root: classes.actionRoot}}>
          <Button color='secondary' onClick={onCloseModal}> CANCEL </Button>
          <Button color='secondary' variant='contained'  disabled={saveInProgress} onClick={onClickCreate}> {isEdit ? 'SAVE' : 'CREATE'}
          {saveInProgress &&
          <CircularProgress
            size={24}
            className={classes.buttonProgress}
          />} 
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/modal/components/Modal.tsx